'use strict';

const React = require('react');
const classNames = require('classnames');
const CloseIcon = require('dibs-vg/dist/react/close');
const LogoNoRegIcon = require('dibs-vg/dist/react/logo-no-reg');
const StorefrontIcon = require('dibs-vg/dist/react/storefront');
const MessageIcon = require('dibs-vg/dist/react/message');
const CartIcon = require('dibs-vg/dist/react/cart');
const ContextComponent = require('../../global/components/ContextComponent');

const style = require('./Introduction-style.scss');
const copy = require('./introduction-copy.json');
const {localStorage} = require('dibs-browser-storage');

const Modal = require('../../global/components/Modal');
const introductionTracking = require('./introduction-trackingActions');

const ICONS = {
    storefront: StorefrontIcon,
    message: MessageIcon,
    cart: CartIcon
};

class Introduction extends ContextComponent {

    constructor(props) {
        super(props);

        this.state = {
            isVisibleBanner: true,
            isVisibleModal: false
        };

        this._modalOpen = this._modalOpen.bind(this);
        this._modalClose = this._modalClose.bind(this);
    }

    _modalOpen() {
        this.setState({ isVisibleModal: true });
        this.setState({ isVisibleBanner: false });

        localStorage.setItem('dibsIntroduction', true);

        this.context.executeAction(introductionTracking.trackEcommerceClick);
    }

    _modalClose() {
        this.setState({ isVisibleModal: false });
    }

    _getIcon(iconKey) {
        return ICONS[iconKey] || null;
    }

    _renderHighlights() {
        return copy.modal.highlights.map(item => {
            const Icon = this._getIcon(item.icon);
            return (
                <div className={`${style.item} colLg4 colMd4 colXs12`} key={`highlights-${item.icon}`}>
                    <Icon className={style.itemIcon} />
                    <div className={style.itemTitle}>{item.title}</div>
                    <div className={style.itemText}>{item.text}</div>
                </div>
            );
        });
    }

    _getModalContent() {
        return (
            <div className="containerFluid boxSizingWrapper">
                <div className={`${style.modalWrapper} rowFlex colLg12 colMd12`} style={{backgroundImage: `url(${copy.modal.background})`}}>
                    <span onClick={this._modalClose}>
                        <CloseIcon className={style.close} />
                    </span>

                    <div className={`${style.container} colMdCenter`}>
                        <LogoNoRegIcon className={style.modalLogo} />
                        <div className={style.modalHeader}>{copy.modal.header}</div>
                        <div className={style.modalSubheader}>{copy.modal.subheader}</div>
                    </div>
                </div>

                <div className={`${style.modalHighlights} rowFlex`}>
                    {this._renderHighlights()}
                </div>
            </div>
        );
    }

    _getBannerContent() {
        const bannerClass = classNames(style.wrapper, {
            [style.isHidden]: !this.state.isVisibleBanner
        });
        const containerClass = classNames(style.container, {
            'isAnimatedContainer': this.state.isVisibleBanner
        });

        return (
            <div className={bannerClass} style={{backgroundImage: `url(${copy.background})`}}>
                <div className={containerClass}>
                    <div className={style.header}>{copy.header}</div>
                    <div className={style.subheader}>{copy.subheader}</div>
                    <button className="button button-primary button-medium" onClick={this._modalOpen}>
                        {copy.cta}
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const isVisibleModal = this.state.isVisibleModal;

        return (
            <div>
                {this._getBannerContent()}

                <Modal isOpen={isVisibleModal} className={style.modal}>
                    {this._getModalContent()}
                </Modal>
            </div>
        );
    }
}

module.exports = Introduction;



// WEBPACK FOOTER //
// ./assets/js/components/Introduction/Introduction.jsx